import axios from 'axios';


//企业点评
//企业点评 添加
export const EnterrpriseReviewAdd = params => {
  return axios.post("/enterpriseReview/add", params).then(res => res.data);
};
export const unwantedTokenUploadFile = params => {
  return axios.post("/annex/unwantedTokenUploadFile", params).then(res => res.data);
};
export const unwantedTokenDeleteFileForSingle = params => {
  return axios.post("/annex/unwantedTokenDeleteFileForSingle", params).then(res => res.data);
};
//视频
export const Vedio = params => {
  return axios.post("/externalEquipment/cameraDataAndYS", params.params).then(res => res.data);
};
//视频
export const VedioPlay = params => {
  return axios.post("/yunMou/getPreviewUrl", params.params).then(res => res.data);
};

// //获取食品安全相关知识列表
// export const ConsumerTipsData = params => {
//   return axios.post("/publicNotice/getPageDataWeChat", params.params).then(res => res.data);
// };
//获取食品安全相关知识列表
export const ConsumerTipsData = params => {
  return axios.post("/info/getPageData", params.params).then(res => res.data);
};

//获取视频流
export const GetVideoUrl = params => {
  return axios.get("/ExternalEquipment/GetVideoUrl", params).then(res => res.data);
};

//验证授权码
export const IsAuthCode = params => {
  return axios.get("/ExternalEquipment/IsAuthCode", params).then(res => res.data);
};

//获取某个食品安全相关知识详细内容
// export const ConsumerTipsByUnid = params => {
//   return axios.post("/publicNotice/findByIdWeChat", params.params).then(res => res.data);
// };
//获取某个食品安全相关知识详细内容
export const ConsumerTipsByUnid = params => {
  return axios.post("/info/findById", params.params).then(res => res.data);
};

//根据企业标识获取企业相关信息
export const SingleEnterprise = params => {
  return axios.post("/enterprise/findByIdWeChat", params.params).then(res => res.data);
};

//根据企业标识获取企业检查次数
export const SingleEnterpriseCheckNumber = params => {
  return axios.get("/DataApi/GetSingleEnterpriseCheckNumber", params).then(res => res.data);
};

//根据企业标识获取人员列表数据
export const EnterprisePersonData = params => {
  return axios.post("/enterprisePerson/getPageData", params.params).then(res => res.data);
};

//根据企业标识获取食品添加剂使用公示数据
export const foodAdditivesgetPageData = params => {
  return axios.post("/foodAdditives/getPageData", params.params).then(res => res.data);
};
//根据企业标识获取原料索证公示数据
export const DemandCertificateData = params => {
  return axios.post("/demandCertificate/getPageData", params.params).then(res => res.data);
};

//获取token 
export const GetToken = params => {
  return axios.get("/Tocken/GetTocken", params).then(res => res.data);
};

//登录
export const requestLogin = params => {
  return axios.get("/Base/Login", params).then(res => res.data);
};

//评分
// export const EvaluationScoring = params => {
//   return axios.post("/EvaluationScoring/Add", params.params).then(res => res.data);
// };
export const EvaluationScoring = params => {
  return axios.post("/EvaluationScoring/Add", params.params).then(res => res.data);
}; //添加
// export const KeepSampledAdd = params => { return axios.post("/api/Dinner/Add", params.params).then(res => res.data); };//添加
// http://192.168.31.19/api/Tocken/GetTocken?ids=dc6d6633dc2a4f5197178ec2d44b025e
//排行
export const GetEnterpriseScoreTop10 = params => {
  return axios.post("/Enterprise/GetEnterpriseScoreTop10", params.params).then(res => res.data);
};

export const GetGuid = params => {
  return axios.post("/Common/getGuid", params.params).then(res => res.data);
}; //32unid


//违法行为
export const SubjectCreditRewardPunish = params => {
  return axios.post("/SubjectCreditRewardPunish/GetPagedata", params.params).then(res => res.data);
};

//监督抽查
export const SubjectCreditExtractCheck = params => {
  return axios.post("/SubjectCreditExtractCheck/GetPagedata", params.params).then(res => res.data);
};


//宣传展示
export const entAppAdvertisement = params => {
  return axios.post("/entAppAdvertisement/getPageData", params.params).then(res => res.data);
};


//宣传展示
export const AnnexGetData = params => {
  return axios.post("/annex/getData", params.params).then(res => res.data);
};

// 企业资质
export const dataApiGetEnterprise = params => {
  return axios.post("/dataApi/getEnterprise", params.params).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/api.js